import { render, staticRenderFns } from "./attribute.vue?vue&type=template&id=6a64a13f&scoped=true&"
import script from "./attribute.vue?vue&type=script&lang=js&"
export * from "./attribute.vue?vue&type=script&lang=js&"
import style0 from "./attribute.vue?vue&type=style&index=0&id=6a64a13f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a64a13f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/merchant_5Yxh/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a64a13f')) {
      api.createRecord('6a64a13f', component.options)
    } else {
      api.reload('6a64a13f', component.options)
    }
    module.hot.accept("./attribute.vue?vue&type=template&id=6a64a13f&scoped=true&", function () {
      api.rerender('6a64a13f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/decoration/modules/auction_meeting/attribute.vue"
export default component.exports